import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { urlEndPoints } from '../../shared/config/end-points';

@Injectable({
  providedIn: 'root',
})
export class RetryInterceptor implements HttpInterceptor {
  private readonly otpEndpoints = [urlEndPoints.users + 'verify-otp', urlEndPoints.users + 'send-otp'];

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.otpEndpoints.includes(request.url)) {
      return next.handle(request);
    }
    return next.handle(request).pipe(
      retry(3),
      catchError((error: any) => {
        throw error;
      })
    );
  }
}
